import { LocationStrategy } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { ROUTE_PATH } from 'common/constants/sm-constants';
import { TokenService } from 'common/services/core-services/get-token.service';
import { NavigationService } from 'common/services/core-services/navigation.service';
import { SystemService } from 'common/services/core-services/system.service';
import { AppWidgetService } from 'common/widget/app-service/app-widget.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'Siemens';
  private history: string[] = [];
  maintenanceCheckInterval: any;
  private readonly CHECK_INTERVAL = 20000;
  tokenDetails: any;
  isPublicStandaloneRoute = false;
  constructor(protected router: Router, protected ss: SystemService, private location: LocationStrategy, private widService: AppWidgetService, private cdr: ChangeDetectorRef, private tokenService: TokenService,

  ) {
    // history.pushState(null, null, window.location.href);
    // this.location.onPopState(() => {
    //   this.handlePopState(this.history);
    // });
  }

  ngOnInit(): void {
    try {
      const isValidProfileKey = this.ss.getlocalStorage('loginData');

      if (!isValidProfileKey && this.ss.checkLogin()) {
        throw new Error("Invalid login data");
      }
    } catch (e) {
      console.error("Error accessing login data:", e);
      this.ss.clearLocalStorage();
      location.reload();
    }
    this.updateRouteFlags(window.location.pathname + window.location.search);

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.urlAfterRedirects;
        this.history.push(currentUrl);
        this.updateRouteFlags(currentUrl);
      }
    });
    const token = localStorage.getItem('token');
    this.tokenDetails = token ? this.tokenService.getDetailsFromToken(token) : null;

    if (
      this.tokenDetails?.tokenData?.role !== 1 &&
      this.tokenDetails?.tokenData?.role !== 4
    ) {

      this.startMaintenanceCheck();
      this.isServerUnderMentanance();
    }

    
  }

  handlePopState(history): void {
    const currentUrl = this.router.url;
    if (history.length !== 0) {
      history.pop();
      const previousUrl = history[history.length - 1];
      // this.ss.navigateByUrl(previousUrl, JSON.parse(localStorage.getItem('routeEnvelope')))
    } else {
      this.ss.navigateToDashboard(); // Navigate to the dashboard if history is empty
    }
  }

  isDashboardUrl(url: string): boolean {
    // Replace '/dashboard' with your actual dashboard route if it's different
    return url === ROUTE_PATH.dashboard;
  }

  getCurrentYear() {
    return new Date().getFullYear();
  }

  private updateRouteFlags(url: string): void {
    this.isPublicStandaloneRoute =
      url.includes('/admin/applications/upload') ||
      url.includes('/privacynotice') ||
      url.includes('/mentor-feedback') ||
      url.includes('scholarship/apply') ||
      url.includes('resetpassword');
  }

  private startMaintenanceCheck(): void {
    // Initial check
    this.isServerUnderMentanance();

    // Set up periodic checking
    this.maintenanceCheckInterval = setInterval(() => {
      this.isServerUnderMentanance();
    }, this.CHECK_INTERVAL);
  }

  isServerUnderMentanance() {
    this.widService
      .Save()
      .then((data: any) => {

        const maintenance = data.details.find(
          (ele: any) => ele.app_type === 'maintenance'
        );

        if (maintenance && maintenance.force_update === 1) {
          this.ss.underMaintenance = true;
        } else {
          this.ss.underMaintenance = false;
        }

        // Trigger change detection to update the view
        this.cdr.detectChanges();
      })
      .catch((error) => {
        console.log(error.message, 'error');
        // Set maintenance to false in case of error
        this.ss.underMaintenance = false;
        this.cdr.detectChanges();
      });
  }

}
